/* Vertical thumbnail rail navigation (desktop only).
   Caps the single-column thumbnail list to the hero image height and adds
   up/down scroll arrows. The up arrow appears only after scrolling down;
   the down arrow hides once the bottom is reached. */
(function () {
  // The rail is hidden on mobile. Avoid layout reads, observers, and timers
  // there so the product hero can paint without desktop-only work competing.
  if (!window.matchMedia('(min-width: 750px)').matches) return;

  var UP_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 15l6-6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DOWN_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(slider) {
    if (slider.dataset.vnavInit) return;
    var list = slider.querySelector('.thumbnail-list');
    if (!list) return;
    slider.dataset.vnavInit = '1';

    var gallery = slider.closest('media-gallery');
    var hero = gallery && gallery.querySelector('[id^="Slider-Gallery"]');

    var up = document.createElement('button');
    up.type = 'button';
    up.className = 'thumb-vnav thumb-vnav--up';
    up.setAttribute('aria-label', 'Scroll thumbnails up');
    up.innerHTML = UP_SVG;

    var down = document.createElement('button');
    down.type = 'button';
    down.className = 'thumb-vnav thumb-vnav--down';
    down.setAttribute('aria-label', 'Scroll thumbnails down');
    down.innerHTML = DOWN_SVG;

    slider.appendChild(up);
    slider.appendChild(down);

    var layoutFrame = 0;
    var updateFrame = 0;

    function update() {
      updateFrame = 0;
      var scrollHeight = list.scrollHeight;
      var clientHeight = list.clientHeight;
      var scrollTop = list.scrollTop;
      var canScroll = scrollHeight - clientHeight > 2;
      var atTop = scrollTop <= 2;
      var atBottom = scrollTop >= scrollHeight - clientHeight - 2;
      up.hidden = !canScroll || atTop;
      down.hidden = !canScroll || atBottom;
    }

    function scheduleUpdate() {
      if (!updateFrame) updateFrame = requestAnimationFrame(update);
    }

    function scheduleLayout() {
      if (layoutFrame) return;
      layoutFrame = requestAnimationFrame(function () {
        layoutFrame = 0;
        var h = hero ? hero.getBoundingClientRect().height : 0;
        if (h > 0) list.style.maxHeight = Math.round(h) + 'px';
        // Measure the constrained rail in the next frame, after max-height applies.
        scheduleUpdate();
      });
    }

    function page(dir) {
      list.scrollBy({ top: dir * list.clientHeight * 0.8, behavior: 'smooth' });
    }

    up.addEventListener('click', function () { page(-1); });
    down.addEventListener('click', function () { page(1); });
    list.addEventListener('scroll', scheduleUpdate, { passive: true });

    if (window.ResizeObserver && hero) {
      new ResizeObserver(scheduleLayout).observe(hero);
    }
    window.addEventListener('resize', scheduleLayout, { passive: true });

    scheduleLayout();
    // Thumbnails load lazily and can change scrollHeight after paint.
    setTimeout(scheduleLayout, 400);
  }

  function initAll() {
    document.querySelectorAll('media-gallery slider-component.thumbnail-slider').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
